module.exports = __webpack_public_path__ + "img/seo_gegame_item01.ede63e3.webp";